
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="px-6 py-12">
        <div className="max-w-6xl mx-auto">
          {/* Brand Section */}
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/301b91c9adaca0684fe24f931e418917/555ed6a9fc9e70bc6df8fb3fee5626b3.jpeg"
                alt="Redeeming Power Ministry Logo"
                className="h-10 w-10 object-contain"
              />
              <div className="text-xl font-bold text-amber-600" style={{fontFamily: '"Pacifico", serif'}}>
                Redeeming Power Ministry
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-2xl mx-auto">
              Sharing revelation knowledge from the Word of God about racism, wealth, and power. 
              Join our community of readers seeking truth and understanding.
            </p>
            <div className="space-y-2 text-gray-300">
              <div>
                <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                  <i className="ri-mail-line"></i>
                </div>
                Redeemingpower2025@gmail.com
              </div>
              <div>
                <div className="w-5 h-5 inline-flex items-center justify-center mr-2">
                  <i className="ri-phone-line"></i>
                </div>
                862-772-6409
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 px-6 py-6">
        <div className="text-center text-gray-400 text-sm">
          <p>&copy; 2024 Author Website. All rights reserved. | <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}
